<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">角色</span>
        <el-input v-model.trim="name" placeholder="请输入角色名" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="createDate"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; getUserRolePageFn()">
          搜索
        </el-button>
        <el-button type="primary" @click="editBtn(1)">
          新增角色
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="name" label="角色"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建日期"></el-table-column>
      <el-table-column align="center" prop="updateTime" label="更新日期"></el-table-column>
	  <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" @click="editBtn(2, row)">编辑</a>
          <a class="glob-a" @click="editBtn(3, row)">删除</a>
          <!-- <a class="glob-a" @click="editBtn(4, row)">权限设置treeTwo</a> -->
		   <a class="glob-a" @click="editBtn(5, row)">权限设置</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 新增角色 -->
    <el-dialog :title="editData.add === 1 ? '新增角色' : '编辑角色'" :visible.sync="editData.modal" width="500px">
      <el-form label-width="120px">
        <el-form-item label="角色名称">
          <el-input v-model.trim="editData.roleName" placeholder="请输入角色名称"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addBtn()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 权限设置 -->
    <el-dialog title="系统权限设置(TreeTwo)" :visible.sync="authData.modal" fullscreen>
      <el-table class="my-table" :data="authData.tableData" :header-row-class-name="'my-table-header'">
        <el-table-column align="center" prop="lineNumber" width="100px" label="行号"></el-table-column>
        <el-table-column align="center" prop="name.name" width="300px" label="名称"></el-table-column>
        <el-table-column align="left" label="权限明细">
          <template slot-scope="{row}">
            <el-checkbox v-model="row.allCheck" @change="authAllChange($event, row)"
                         :indeterminate="row.indeterminate">
              全选
            </el-checkbox>
            <el-checkbox-group class="mt20" v-model="row.checkedList" @change="authChange($event, row)">
              <el-checkbox v-for="(item,index) in row.subModuleList" :label="item.id" :key="index">
                {{item.name}}
              </el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>


      <div slot="footer">
        <el-button @click="authData.modal = false">取 消</el-button>
        <el-button type="primary" @click="authSave">确 定</el-button>
      </div>
    </el-dialog>
	
	<!-- tree -->
	<el-dialog title="系统权限设置" :visible.sync="authTreeData.modal" fullscreen>
		<el-tree
		  :data="authTreeData.tableData"
		  :check-strictly="checkStrictly" 
		  show-checkbox
		  ref="authTree"
		  highlight-current 
		  node-key="functionId"
		  default-expand-all
		  @check-change="handleCheckChange"
		  @node-click="handleNodeClick"
		  @check="handleCheck"
		  :props="{id:'functionId',label:'functionName'}">
		</el-tree>
				
	  <div slot="footer">
	    <el-button @click="authTreeData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="authTreeSave">确 定</el-button>
	  </div>
	</el-dialog>

  </div>
</template>

<script>
  import {
	//条件查询角色列表
	getUcManagePage,
	//新增角色
	addUcManageUp,
	//修改角色
	updateUcManageUp,
	//删除角色
	delUcManageUpRe,
	  
    getUserRolePage,
    addUserRole,
    editUserRole,
    delUserRole,
    getSystemPermSettings,
    addUserRoleFun,
	
	//查看选中角色树权限菜单
	getSystemPermTreeSettings,
	//保存管理菜单权限，新增或修改
	ucUserManageAuto
	
  } from '@/api/index'

  export default {
    name: 'RoleAuth',
    data () {
      return {
		//角色名称
        name: '',
        createDate: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        editData: {
          modal: false,
          add: 1,
          roleName: '',
          roleId: ''
        },
        // 权限设置
        authData: {
          modal: false,
          roleId: '',
          tableData: [],
          tableLoading: false,
        },
		// tree
		tableDataTree:"",
		authTreeData: {
		  modal: false,
		  roleId: '',
		  tableData: [],
		  tableLoading: false,
		  //拥有权限集合
		  checkedList:''
		},
		checkStrictly: false,
		//权限Tree选中的节点
		moduleids: [],
				
		props: {
		          label: 'name',
		          children: 'zones'
		        },
		 count: 1,
				
      }
    },
    created () {
      this.getUserRolePageFn()
    },
    methods: {
      authSave () {
        let data =  this.authData.tableData;
        let checkArray = [];
        data.forEach(item => {
          let subName = item.name;
          let subItem = item.checkedList;
          let length = subItem.length;
          //数组有值在追加到一起
          if(length!=0){
           let id = subName.id;
            checkArray.push(id);
            subItem.forEach(item =>{
              checkArray.push(item);
            });
          }
        });
        addUserRoleFun({
          roleId: this.authData.roleId,
          functionIds: checkArray,
        }).then(res => {
          this.$message.success(res.data)
          this.authData.modal = false
        })
      },
	  //tree 保存
	  authTreeSave(){
		  console.info("-=-=-this.authTreeData.roleId:",this.authTreeData.roleId)
		  
		  if (this.moduleids.length <= 0) {
		    this.$message({
		        showClose: true,
		        message: '请选择权限分配给指定角色！',
		        type: 'error'
		    });
		    return false;
		   }
		   //保存管理菜单权限，新增或修改
		    this.tableLoading = true
		   ucUserManageAuto({
			 //角色编号  
		     manageId:this.authTreeData.roleId,
			 //角色权限集合
		     manageAuthIds: this.moduleids,
			 //权限名 ORGSTRUCT组织架构 SUPERADMIN超级管理员
			 name:"SUPERADMIN"
		   }).then(res => {
		  
		  if(res.code === 200 ){
		     this.authTreeData = {
		         modal: false
		    }
		   }else{
				this.$message({
				    showClose: true,
				    message: res.msg,
				    type: 'error'
				});
			}
		   }).finally(() => {
		     this.tableLoading = false
		   })
		   
		console.info("保存分配到的权限",this.moduleids)   
				  
	  },
      authAllChange (val, row) {
        row.checkedList = val ? row.subModuleList.map(item => item.id) : []
        row.indeterminate = false
      },
      authChange (value, row) {
        let checkedCount = value.length
        row.allCheck = checkedCount === row.checkedList.length
        row.indeterminate = checkedCount > 0 && checkedCount < row.subModuleList.length
      },
      getUserRolePageFn () {
        this.tableLoading = true
        getUcManagePage({
          pageNum: this.pages.page,
          name: this.name,
          createTime: this.createDate && this.createDate.length ? this.createDate[0] : '',
          updateTime: this.createDate && this.createDate.length > 1 ? this.createDate[1] : '',
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getUserRolePageFn()
      },
      addBtn () {
        if (this.editData.add == 1) {
          //确定保存
          addUcManageUp({
            name: this.editData.roleName,
          }).then(res => {
            this.$message.success(res.msg)
            this.editData.modal = false
            this.getUserRolePageFn();
          })
        } else {
          //确定编辑
          updateUcManageUp({
            id: this.editData.roleId,
            name: this.editData.roleName,
          }).then(res => {
            this.$message.success(res.msg)
            this.editData.modal = false
            this.getUserRolePageFn();
          })
        }
      },
      //1新增 2编辑 3删除 4权限设置 //5 tree树
      editBtn (t, row) {
        switch (t) {
          case 1:
            //弹出新增角色弹出层
            this.editData = {
              modal: true,
              add: 1,
              roleName: ''
            }
            break

          case 2:
            //弹出编辑角色弹出层
            this.editData = {
              modal: true,
              add: 2,
              roleId: row.id,
              roleName: row.name
            }
            break

          case 3:
            this.$confirm(`确认要删除吗`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            delUcManageUpRe({
                umIds: [row.id],
            }).then(res => {
                this.$message.success(res.msg)
                this.getUserRolePageFn()
              })
            }).catch(() => {
            })
            break

          case 4:
            getSystemPermSettings({
				id:row.id
			}).then(res => {
              let tableData = res.data
              tableData.forEach(item => {
                item.indeterminate = false
                item.allCheck = item.subModuleList.every(subName => subName.flag)
                item.checkedList = item.subModuleList.filter(subName => subName.flag).map(subName => subName.id)
				console.info("item.checkedList : " + item.checkedList)
              })
              this.authData = {
                modal: true,
                roleId: row.roleId,
                tableData
              }
            })
            break
			
			//tree 树
			case 5:
			this.authTreeData.roleId = row.id
			getSystemPermTreeSettings({
				id:row.id
			}).then(res => {
				this.authTreeData.tableData = res.data.funTreeDTOList
				let haveAuthority = res.data.haveAuthority		
				if (haveAuthority) {
					this.checkStrictly = true 
					haveAuthority.forEach(value=>{//真的大坑，我自己摸索好久！！！
					this.$nextTick(() => {
					console.info("haveAuthority    ",value)
					this.$refs.authTree.setChecked(value,true,false) //给树节点赋值
					 })
					this.checkStrictly = false //重点： 赋值完成后 设置为false
					})
				}
			 this.authTreeData.modal = true		
			})
			break
        }
      },
	    handleCheckChange(){
			
	    },
		handleCheck(data,checked){
			//checked.checkedKeys  选中的节点id数组z
			//checked.halfCheckedKeys 半选中节点id数组
			this.moduleids = checked.halfCheckedKeys.concat(checked.checkedKeys); //选中节点和半选中节点所有的id
		},
		handleNodeClick(data, node) {
				 console.info("节点双击事件");
	    }
    }
  }
</script>

<style scoped>

</style>
